import { render } from "./icon-image.vue?vue&type=template&id=661a8c5b"
const script = {}

import exportComponent from "C:\\projects\\equistasi\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__